import React, {
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FollowUpAgenciamentoContext from '../../../../contexts/import/follow-up/FollowUpAgenciamentoContext';
import followUpExportacaoSelectors from '../../../../features/follow-up-agenciamento/followUpAgenciamentoSelectors';
import {
  followUpAgenciamentoActions,
} from '../../../../features/follow-up-agenciamento/followUpAgenciamentoSlice';
import QCXPageTemplate from '../../../../templates/page/QCXPageTemplate';
import { isFailureStatus, isLoadingStatus, isSuccessStatus } from '../../../../utils/store/store-utils';

export default function FollowUpAgenciamentoPage({ children }) {
  const dispatch = useDispatch();

  const status = useSelector(
    followUpExportacaoSelectors.selectStatus
  );
  const error = useSelector(
    followUpExportacaoSelectors.selectError
  );
  const response = useSelector(
    followUpExportacaoSelectors.selectResponse
  );

  const modeSelectors = useMemo(() => ({
    selectMode: followUpExportacaoSelectors.selectMode,
    selectSubMode: followUpExportacaoSelectors.selectSubMode,
    selectBackgroundMode: followUpExportacaoSelectors.selectBackgroundMode,
  }), [followUpExportacaoSelectors]);

  const isLoading = useMemo(() => (
    isLoadingStatus(status)
  ), [status]);

  const [successSnackbar, setSuccessSnackbar] = useState({
    open: false,
    message: '',
  });

  const [errorSnackbar, setErrorSnackbar] = useState({
    open: false,
    message: '',
  });

  const handleOpenSuccessSnackbar = useCallback((message) => {
    setSuccessSnackbar({
      open: true,
      message,
    });
  }, []);

  const handleOpenErrorSnackbar = useCallback((message) => {
    setErrorSnackbar({
      open: true,
      message,
    });
  }, []);

  const handleCloseSuccessSnackbar = useCallback(() => {
    setSuccessSnackbar({
      ...successSnackbar,
      open: false,
    });
  }, []);

  const handleCloseErrorSnackbar = useCallback(() => {
    setErrorSnackbar({
      ...errorSnackbar,
      open: false,
    });
  }, []);

  useEffect(() => {
    const handleStatus = () => {
      if (isFailureStatus(status) && error && error.message) {
        handleOpenErrorSnackbar(error.message);
        dispatch(followUpAgenciamentoActions.resetStatus());
        dispatch(followUpAgenciamentoActions.clearError());

        return;
      }
      if (isSuccessStatus(status) && response && response.message) {
        handleOpenSuccessSnackbar(response.message);
        dispatch(followUpAgenciamentoActions.resetStatus());
        dispatch(followUpAgenciamentoActions.clearResponse());
      }
    };

    handleStatus();
  }, [response, status, error]);

  const providerData = useMemo(() => ({
    status,
    isLoading,
    successSnackbar,
    errorSnackbar,
    handleCloseSuccessSnackbar,
    handleCloseErrorSnackbar,
  }), [
    status,
    isLoading,
    successSnackbar,
    errorSnackbar,
  ]);

  return (
    <FollowUpAgenciamentoContext.Provider
      value={providerData}
    >
      <QCXPageTemplate
        contextComponent={FollowUpAgenciamentoContext}
        modeSelectors={modeSelectors}
      >
        {children}
      </QCXPageTemplate>
    </FollowUpAgenciamentoContext.Provider>
  );
}
